<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på leverantörer</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import SupplierRepository from '@services/repositories/SupplierRepository';

export default {
    name: 'SupplierFilter',
    components: {
        VueSelect,
    },
    data() {
        return {
            options: [],
        };
    },
    async created() {
        const client = new SupplierRepository();
        client.getAll().then((res) => {
            this.options = res.map((item) => ({
                id: item.ProdSupplierID,
                label: item.Name,
            }));
        });
    },
};
</script>
